var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.value, persistent: "", width: "900" },
      on: {
        "click:outside": function($event) {
          return _vm.close()
        }
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "pl-6 pr-2 pt-4 pb-0" },
            [
              _c(
                "v-icon",
                { staticClass: "mr-2", attrs: { color: "warning" } },
                [_vm._v("mdi-alert")]
              ),
              _c("div", { staticClass: "title h6" }, [
                _vm._v(" Net Unit Allowance Warning ")
              ])
            ],
            1
          ),
          _c(
            "v-container",
            { staticClass: "pa-0", attrs: { fluid: "" } },
            [
              _c("div", { staticClass: "mx-6 my-4" }, [
                _vm._v(
                  " Please review before proceeding. The following promo items have a net unit allowance amount less than $0.10. "
                )
              ]),
              _c("v-data-table", {
                staticClass: "mx-4",
                attrs: {
                  items: _vm.promoItems,
                  headers: _vm.headers,
                  "no-data-text": "No promo item net unit allowance violations",
                  dense: "",
                  "fixed-header": "",
                  "disable-pagination": "",
                  "hide-default-footer": "",
                  "items-per-page": -1,
                  height: _vm.tableHeight
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "item.item.description",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          item.item.description
                            ? _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              "span",
                                              _vm._g(
                                                _vm._b(
                                                  {},
                                                  "span",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      item.item.description.substring(
                                                        0,
                                                        10
                                                      )
                                                    ) +
                                                    _vm._s(
                                                      item.item.description
                                                        .length > 10
                                                        ? "..."
                                                        : ""
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(item.item.description))
                                  ])
                                ]
                              )
                            : _c("span", [_vm._v("-")])
                        ]
                      }
                    },
                    {
                      key: "item.net_unit_allowance",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          item.net_unit_allowance ||
                          item.net_unit_allowance === 0
                            ? _c("span", [
                                _vm._v(
                                  "$" +
                                    _vm._s(
                                      _vm.$config.formatCurrency(
                                        item.net_unit_allowance
                                      )
                                    )
                                )
                              ])
                            : _c("span", [_vm._v("-")])
                        ]
                      }
                    },
                    {
                      key: "item.sum_scan_allowances",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          item.sum_scan_allowances ||
                          item.sum_scan_allowances === 0
                            ? _c("span", [
                                _vm._v(
                                  "$" +
                                    _vm._s(
                                      _vm.$config.formatCurrency(
                                        item.sum_scan_allowances
                                      )
                                    )
                                )
                              ])
                            : _c("span", [_vm._v("-")])
                        ]
                      }
                    },
                    {
                      key: "item.sum_billback_allowances",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          item.sum_billback_allowances ||
                          item.sum_billback_allowances === 0
                            ? _c("span", [
                                _vm._v(
                                  "$" +
                                    _vm._s(
                                      _vm.$config.formatCurrency(
                                        item.sum_billback_allowances
                                      )
                                    )
                                )
                              ])
                            : _c("span", [_vm._v("-")])
                        ]
                      }
                    }
                  ],
                  null,
                  true
                )
              }),
              _c(
                "div",
                { staticClass: "mt-4 d-flex justify-center" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mb-4 mr-4",
                      attrs: { text: "" },
                      on: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [_vm._v(" Cancel ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mb-4",
                      attrs: { color: "warning" },
                      on: {
                        click: function($event) {
                          return _vm.confirm()
                        }
                      }
                    },
                    [_vm._v(" Confirm ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }